<template>
  <v-card flat>
    <v-card-text v-if="!localLoading">
      <v-row>
        <v-col cols="12" sm="4" md="3">
          <v-select
            v-model="selectedReportType"
            :items="reportTypes"
            return-object
            item-text="Name"
            hide-details
            label="Report type"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-if="
            selectedReportType.Code === 'PAYOUT' ||
              (selectedReportType.Code === 'FINANCE' &&
                selectedReportType.ID === 1) ||
              selectedReportType.ID === 4
          "
          cols="12"
        >
          <v-btn small text @click="setSelectedDateRange(0)">
            {{ $vuetify.lang.t('$vuetify.FROM_PREVIOUS_MONTH_START') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(1)">
            {{ $vuetify.lang.t('$vuetify.PREVIOUS_MONTH') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(2)">
            {{ $vuetify.lang.t('$vuetify.CURRENT_MONTH') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(3)">
            {{ $vuetify.lang.t('$vuetify.PREVIOUS_WEEK') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(4)">
            {{ $vuetify.lang.t('$vuetify.CURRENT_WEEK') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(5)">
            {{ $vuetify.lang.t('$vuetify.YESTERDAY') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(6)">
            {{ $vuetify.lang.t('$vuetify.TODAY') }}
          </v-btn>
          <v-btn small text @click="setSelectedDateRange(7)">
            {{ $vuetify.lang.t('$vuetify.LAST_7_DAYS') }}
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="selectedReportType.Code === 'PAYOUT'">
        <v-row>
          <v-col v-if="userRegions.length > 1" cols="12" sm="2">
            <v-select
              v-model="selectedRegion"
              :items="userRegions"
              hide-details
              :label="$vuetify.lang.t('$vuetify.REGION')"
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
              outlined
              prepend-inner-icon="mdi-earth"
            />
          </v-col>
          <v-col v-show="user.place_types.length > 1" cols="12" sm="2">
            <v-select
              v-model="selectedType"
              :items="user.place_types"
              hide-details
              :label="$vuetify.lang.t('$vuetify.TYPE')"
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
              outlined
            ></v-select>
          </v-col>
          <v-col v-if="userZones.length > 1" cols="12" sm="2">
            <v-autocomplete
              v-model="selectedReportZone"
              :items="userZones"
              hide-details
              outlined
              clearable
              :label="$vuetify.lang.t('$vuetify.SELECT_ZONE')"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <v-menu
              v-model="validFromPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="datePickerFormat(selectedValidFrom)"
                  :label="$vuetify.lang.t('$vuetify.STATISTICS.FROM')"
                  :placeholder="$vuetify.lang.t('$vuetify.STATISTICS.FROM')"
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  @click:clear="validFrom = null"
                  @click:append="validFromPicker = !validFromPicker"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedValidFrom"
                @input="validFromPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2">
            <v-menu
              v-model="validToPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="datePickerFormat(selectedValidTo)"
                  :label="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                  :placeholder="$vuetify.lang.t('$vuetify.STATISTICS.TO')"
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  @click:clear="selectedValidTo = null"
                  @click:append="validToPicker = !validToPicker"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedValidTo"
                @input="validToPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col v-if="operators.length > 1" cols="12" sm="2">
            <v-select
              v-model="selectedOperator"
              :items="operators"
              item-text="Name"
              :label="$vuetify.lang.t('$vuetify.OPERATOR')"
              hide-details
              outlined
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="4">
            <v-autocomplete
              v-model="selectedPlace"
              :items="sortedUserPlaces"
              item-text="Name"
              hide-details
              return-object
              :menu-props="{ bottom: true, offsetY: true }"
              clearable
              outlined
              :label="$vuetify.lang.t('$vuetify.SELECT_PLACE')"
              prepend-inner-icon="mdi-map-marker"
            />
          </v-col>
          <v-col
            v-if="userZones.length > 1 && operators.length > 1"
            cols="12"
            sm="2"
          >
            <v-select
              v-model="selectedGroupByValue"
              :items="['PLACE', 'OPERATOR', 'ZONE']"
              :label="$vuetify.lang.t('$vuetify.REPORTS.GROUP_BY')"
              outlined
              hide-details
              :menu-props="{ bottom: true, offsetY: true }"
            ></v-select>
          </v-col>
        </v-row>
      </div>
      <div v-if="selectedReportType.Code === 'FINANCE'">
        <v-row>
          <v-col cols="12" sm="2">
            <v-select
              v-model="selectedRegion"
              :items="userRegions"
              hide-details
              label="Region"
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
              clearable
              outlined
              prepend-inner-icon="mdi-earth"
            />
          </v-col>
          <v-col cols="12" sm="2">
            <v-select
              v-model="selectedType"
              :items="['ALL TYPES', 'PARKING', 'CAR_WASH']"
              hide-details
              label="Type"
              :menu-props="{
                bottom: true,
                offsetY: true
              }"
              outlined
            ></v-select>
          </v-col>
          <v-col cols="12" sm="2">
            <v-menu
              v-model="validFromPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="datePickerFormat(selectedValidFrom)"
                  :label="$vuetify.lang.t('$vuetify.VALID_FROM')"
                  :placeholder="$vuetify.lang.t('$vuetify.VALID_FROM')"
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  @click:clear="validFrom = null"
                  @click:append="validFromPicker = !validFromPicker"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedValidFrom"
                @input="validFromPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="2">
            <v-menu
              v-model="validToPicker"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="datePickerFormat(selectedValidTo)"
                  :label="$vuetify.lang.t('$vuetify.VALID_TO')"
                  :placeholder="$vuetify.lang.t('$vuetify.VALID_TO')"
                  append-icon="mdi-calendar"
                  readonly
                  outlined
                  hide-details
                  clearable
                  v-bind="attrs"
                  @click:clear="selectedValidTo = null"
                  @click:append="validFromPicker = !validFromPicker"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="selectedValidTo"
                @input="validToPicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <div
        v-if="
          selectedReportType.Code !== 'PAYOUT' &&
            selectedReportType.Code !== 'FINANCE'
        "
      >
        <v-row>
          <v-col cols="12" sm="6">
            <v-menu offset-y auto>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" v-bind="attrs" class="mr-4" v-on="on">
                  {{ selectedMonth }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in range(1, 12)"
                  :key="index"
                  @click="selectedMonth = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y auto>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" v-bind="attrs" class="mr-4" v-on="on">
                  {{ selectedYear }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in range(2017, new Date().getFullYear())"
                  :key="index"
                  @click="selectedYear = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
      </div>
      <v-row>
        <v-col cols="12">
          <!-- <v-btn
            v-if="isGlobalAdmin"
            :loading="
              loading.state && loading.type === 'getFinanceXLSX' && !error
            "
            color="white"
            class="success--text"
            :class="$vuetify.breakpoint.smAndDown ? 'mb-3' : 'mr-3'"
            @click="getFinanceXLSXReport()"
          >
            <v-icon class="mr-2">mdi-poll</v-icon>FINANCE
          </v-btn> -->
          <v-btn
            v-if="
              selectedReportType.Code === 'PAYOUT' ||
                selectedReportType.Code === 'FINANCE'
            "
            :loading="loading.state && loading.type === 'getReportRows'"
            color="white"
            class="success--text mr-3"
            :class="$vuetify.breakpoint.smAndDown ? 'mb-3' : ''"
            @click="generatePayoutReport()"
          >
            {{ $vuetify.lang.t('$vuetify.GENERATE') }}
          </v-btn>
          <v-btn
            color="white"
            class="success--text mr-3"
            :class="$vuetify.breakpoint.smAndDown ? 'mb-3' : ''"
            @click="getPayoutReport()"
          >
            <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
            {{ $vuetify.lang.t('$vuetify.EXPORT_TO_EXCEL') }}
          </v-btn>
          <v-btn
            v-if="selectedReportType.SendToEmailEnabled"
            :loading="loading.state && loading.type === 'getReportRows'"
            color="white"
            class="success--text"
            :class="$vuetify.breakpoint.smAndDown ? 'mb-3' : ''"
            @click="sendPayoutReportToEmail()"
          >
            {{ $vuetify.lang.t('$vuetify.SEND_TO_EMAIL') }}
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="reportData" id="summary" class="elevation-2 pa-4">
        <div class="panel-body">
          <div v-if="reportData.ReportTotalView" class="row">
            <div class="col-4 font-weight-bold">
              {{ $vuetify.lang.t('$vuetify.DASHBOARD.SUMMARY') }}
            </div>
            <div class="col-1 font-weight-bold">Count</div>
            <div class="col-2 font-weight-bold">Amount</div>
            <div class="col-1 font-weight-bold">%</div>
            <div
              v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
              class="col-2 font-weight-bold"
            >
              Payment processing cost
            </div>
            <div class="col-2 font-weight-bold">Payment</div>
          </div>
          <div v-if="reportData.ReportTotalView.Rows">
            <div
              v-for="(row, i) in reportData.ReportTotalView.Rows"
              :key="i"
              class="row"
            >
              <div class="col-4">{{ row.PaymentMethod }}</div>
              <div class="col-1">{{ row.Count }}</div>
              <div class="col-2">{{ row.AmountInCents / 100 }}</div>
              <div class="col-1"></div>
              <div
                v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
                class="col-2"
              >
                <span v-if="row.PaymentShareInCents < 0">
                  {{ row.PaymentShareInCents / 100 }}
                </span>
              </div>
              <div class="col-2">
                {{ row.PaymentInCents / 100 }}
              </div>
            </div>
          </div>
          <div
            v-if="reportData.ReportTotalView.TotalSchemaFees < 0"
            class="row"
          >
            <div class="col-4">SCHEMA FEES</div>
            <div class="col-1"></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalSchemaFees }}
            </div>
            <div class="col-1"></div>
            <div
              v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
              class="col-2"
            ></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalSchemaFees }}
            </div>
          </div>
          <div
            v-if="reportData.ReportTotalView.TotalMarkupFees < 0"
            class="row"
          >
            <div class="col-4">MARKUP FEES</div>
            <div class="col-1"></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalMarkupFees }}
            </div>
            <div class="col-1"></div>
            <div
              v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
              class="col-2"
            ></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalMarkupFees }}
            </div>
          </div>
          <div
            v-if="reportData.ReportTotalView.TotalInterchangeFees < 0"
            class="row"
          >
            <div class="col-4">INTERCHANGE FEES</div>
            <div class="col-1"></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalInterchangeFees }}
            </div>
            <div class="col-1"></div>
            <div
              v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
              class="col-2"
            ></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalInterchangeFees }}
            </div>
          </div>
          <div
            v-if="reportData.ReportTotalView.TotalFixedPaymentInCents !== 0"
            class="row"
          >
            <div class="col-4">FIXED MONTHLY PAYMENT</div>
            <div class="col-1">
              {{ reportData.ReportTotalView.TotalFixedPaymentsCount }}
            </div>
            <div class="col-2"></div>
            <div class="col-1"></div>
            <div
              v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
              class="col-2"
            ></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalFixedPaymentInCents / 100 }}
            </div>
          </div>
          <div
            v-if="reportData.ReportTotalView.TotalAdyenPPCInCents < 0"
            class="row"
          >
            <div class="col-4">ADYEN PPC</div>
            <div class="col-1">
              {{ reportData.ReportTotalView.TotalAdyenPPCCount }}
            </div>
            <div class="col-2"></div>
            <div class="col-1"></div>
            <div
              v-if="reportData.ReportTotalView.TotalAdyenPPCInCents < 0"
              class="col-2"
            ></div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalAdyenPPCInCents / 100 }}
            </div>
          </div>
          <div class="row">
            <div class="col-4">TOTAL</div>
            <div class="col-1">
              {{ reportData.ReportTotalView.TotalCount }}
            </div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalAmountInCents / 100 }}
              {{ reportData.GroupViews[0].Currency }}
            </div>
            <div class="col-1"></div>
            <div
              v-if="reportData.ReportTotalView.TotalPaymentShareInCents < 0"
              class="col-2"
            >
              {{ reportData.ReportTotalView.TotalPaymentShareInCents / 100 }}
              {{ reportData.GroupViews[0].Currency }}
            </div>
            <div class="col-2">
              {{ reportData.ReportTotalView.TotalPaymentInCents / 100 }}
              {{ reportData.GroupViews[0].Currency }}
            </div>
          </div>
          <div v-if="isGlobalAdmin" class="row">
            <div class="col-5">BARKING REVENUE</div>
            <div class="col-4">
              <span style="color:green"
                >{{
                  (
                    Math.round(
                      reportData.ReportTotalView.BarkingRevenue * 100
                    ) / 100
                  ).toFixed(2)
                }}&nbsp;{{ reportData.GroupViews[0].Currency }}</span
              >
            </div>
            <div class="col-3"></div>
          </div>
        </div>
      </div>
      <!--SummaryEnd-->
      <v-data-iterator
        v-if="financeData"
        content-tag="tag"
        row
        wrap
        :items="[financeData]"
        rows-per-page="1"
        hide-default-footer=""
      >
        <template v-slot:default="props">
          <v-row>
            <v-col
              v-for="item in props.items"
              :key="item.name"
              cols="12"
              sm="6"
              md="4"
              lg="3"
            >
              <v-card>
                <v-list dense>
                  <v-card-title primary-title>
                    Merchants
                  </v-card-title>
                  <v-list-item>
                    <v-list-item-content>Live locations:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.LiveLocations || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      Working locations:
                    </v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.WorkingLocations || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      Idle locations:
                    </v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.IdleLocations || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>Total locations:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.TotalLocations || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>New locations:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.NewLocations || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>Total sessions:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.TotalSessions || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      Average sessions:
                    </v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.AverageSessions || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>Total revenue:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.TotalRevenue || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>Average revenue:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.AverageRevenue || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-divider></v-divider>
                  <v-card-title primary-title>
                    End user
                  </v-card-title>
                  <v-list-item>
                    <v-list-item-content>Prospects:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.Prospects || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content
                      >Total active customers:</v-list-item-content
                    >
                    <v-list-item-content class="align-end">
                      {{ item.TotalActiveCustomers || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content
                      >New active customers:</v-list-item-content
                    >
                    <v-list-item-content class="align-end">
                      {{ item.NewActiveCustomers || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content
                      >Re-activated customers:</v-list-item-content
                    >
                    <v-list-item-content class="align-end">
                      {{ item.ReActivatedCustomers || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content
                      >Ongoing active customers:</v-list-item-content
                    >
                    <v-list-item-content class="align-end">
                      {{ item.OngoingActiveCustomers || '?' }}
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>Idle customers:</v-list-item-content>
                    <v-list-item-content class="align-end">
                      {{ item.IdleCustomers || '?' }}
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
            <!-- <v-col cols="6">
              <v-sparkline
                :value="[0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0]"
                :gradient="gradients[5]"
                :smooth="10 || false"
                :padding="8"
                :line-width="2"
                :stroke-linecap="'round'"
                :gradient-direction="'top'"
                :fill="false"
                :type="'trend'"
                :auto-line-width="false"
                auto-draw
              ></v-sparkline>
            </v-col> -->
          </v-row>
        </template>
      </v-data-iterator>
      <div v-if="reportData">
        <!-- eslint-disable vue/no-use-v-if-with-v-for -->
        <div
          v-for="report in reportData.GroupViews"
          v-if="reportData"
          :key="report.Id"
          class="col-12 elevation-2 pa-4 mb-3"
        >
          <div class="panel-body">
            <v-row>
              <v-col cols="4" class="font-weight-bold">
                {{ report.Name }}{{ report.Code ? ', ' + report.Code : '' }}
              </v-col>
              <v-col cols="1" class="font-weight-bold">
                Count
              </v-col>
              <v-col cols="2" class="font-weight-bold">
                Amount
              </v-col>
              <v-col cols="1" class="font-weight-bold">
                %
              </v-col>
              <v-col
                v-if="report.TotalPaymentShareInCents < 0"
                cols="2"
                class="font-weight-bold"
              >
                PPC
              </v-col>
              <v-col cols="2" class="font-weight-bold">
                Payment
              </v-col>
            </v-row>

            <v-row v-for="row in report.Rows" :key="row.Id">
              <v-col cols="4">
                {{ row.PaymentMethod }}
              </v-col>
              <v-col cols="1">
                {{ row.Count }}
              </v-col>
              <v-col cols="2">
                {{ row.AmountInCents / 100 }}
              </v-col>
              <v-col cols="1">
                {{ getOwnerShareByPaymentMethod(row) }}
              </v-col>
              <v-col v-if="report.TotalPaymentShareInCents < 0" cols="2">
                <span v-if="row.PaymentShareInCents < 0">
                  {{ row.PaymentShareInCents / 100 }}
                </span>
              </v-col>
              <v-col cols="2" class="col-2">
                {{ row.PaymentInCents / 100 }}
              </v-col>
            </v-row>

            <v-row v-if="report.TotalFixedPaymentInCents !== 0">
              <v-col cols="4">
                FIXED MONTHLY PAYMENT
              </v-col>
              <v-col cols="1">
                {{ report.TotalFixedPaymentsCount }}
              </v-col>
              <div class="col-2"></div>
              <div class="col-1"></div>
              <v-col
                v-if="report.TotalPaymentShareInCents < 0"
                cols="2"
              ></v-col>
              <v-col cols="2">
                {{ report.TotalFixedPaymentInCents / 100 }}
              </v-col>
            </v-row>

            <v-row v-if="report.TotalAdyenPPCInCents < 0">
              <v-col cols="4">
                ADYEN PPC
              </v-col>
              <v-col cols="1">
                {{ report.TotalAdyenPPCCount }}
              </v-col>
              <div class="col-2"></div>
              <div class="col-1"></div>
              <v-col v-if="report.TotalAdyenPPCInCents < 0" cols="2"></v-col>
              <v-col cols="2">
                {{ report.TotalAdyenPPCInCents / 100 }}
              </v-col>
            </v-row>

            <v-row v-if="report.TotalSchemaFees < 0">
              <v-col cols="4">
                SCHEMA FEES
              </v-col>
              <div class="col-1"></div>
              <div class="col-2">{{ report.TotalSchemaFees }}</div>
              <div class="col-1"></div>
              <div
                v-if="report.TotalPaymentShareInCents < 0"
                class="col-2"
              ></div>
              <div class="col-2">{{ report.TotalSchemaFees }}</div>
            </v-row>

            <v-row v-if="report.TotalMarkupFees < 0">
              <div class="col-4">MARKUP FEES</div>
              <div class="col-1"></div>
              <div class="col-2">{{ report.TotalMarkupFees }}</div>
              <div class="col-1"></div>
              <div
                v-if="report.TotalPaymentShareInCents < 0"
                class="col-2"
              ></div>
              <div class="col-2">{{ report.TotalMarkupFees }}</div>
            </v-row>
            <div v-if="report.TotalInterchangeFees < 0" class="row">
              <div class="col-4">INTERCHANGE FEES</div>
              <div class="col-1"></div>
              <div class="col-2">
                {{ report.TotalInterchangeFees }}
              </div>
              <div class="col-1"></div>
              <div
                v-if="report.TotalPaymentShareInCents < 0"
                class="col-2"
              ></div>
              <div class="col-2">
                {{ report.TotalInterchangeFees }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">TOTAL</div>
              <div class="col-1">{{ report.TotalCount }}</div>
              <div class="col-2">
                {{ report.TotalAmountInCents / 100 }}
                {{ report.Currency }}
              </div>
              <div class="col-1"></div>
              <div v-if="report.TotalPaymentShareInCents < 0" class="col-2">
                {{report.TotalPaymentShareInCents / 100 |
              number : 2}}
                {{ report.Currency }}
              </div>
              <div class="col-2 d-flex justify-space-between align-center">
                {{ report.TotalPaymentInCents / 100 }}
                {{ report.Currency }}
                <v-btn
                  v-if="report.TotalAmountInCents > 0"
                  color="success"
                  text
                  @click="showReportDetails(report)"
                >
                  <v-icon>
                    {{
                      !selectedReportRow.showingDetails
                        ? 'mdi-menu-down'
                        : 'mdi-menu-up'
                    }}
                  </v-icon>
                  Details
                </v-btn>
              </div>
            </div>
            <div v-if="isGlobalAdmin" class="row">
              <div class="col-5">BARKING REVENUE</div>
              <div class="col-4">
                <span style="color: green;">
                  {{ report.BarkingRevenue.toFixed(2) }}&nbsp;
                  {{ report.Currency }}
                </span>
              </div>
              <div class="col-3"></div>
            </div>
            <!-- eslint-disable vue/no-use-v-if-with-v-for -->
            <div
              v-if="
                selectedReportRow.showingDetails &&
                  report.Id === selectedReportRow.Id
              "
            >
              <div
                v-for="dailyRow in selectedReportRow.details.Rows"
                :key="dailyRow.Id"
              >
                <div v-if="dailyRow.Rows">
                  <br />
                  <div class="row">
                    <div class="col-12 font-weight-bold">
                      {{ dailyRow.Date }}
                    </div>
                  </div>
                  <div
                    v-for="dayDetails in dailyRow.Rows"
                    :key="dayDetails.Id"
                    class="row"
                  >
                    <div class="col-4">{{ dayDetails.PaymentMethod }}</div>
                    <div class="col-1">{{ dayDetails.Count }}</div>
                    <div class="col-2">
                      {{ dayDetails.AmountInCents / 100 }}
                    </div>
                    <div class="col-1">
                      {{ getOwnerShareByPaymentMethod(dayDetails) }}
                    </div>
                    <div class="col-2">
                      <span v-if="dayDetails.PaymentShareInCents < 0">
                        {{ dayDetails.PaymentShareInCents / 100 }}
                      </span>
                    </div>
                    <div class="col-2">
                      {{ dayDetails.PaymentInCents / 100 }}
                    </div>
                  </div>
                  <div v-if="dailyRow.TotalSchemaFees < 0" class="row">
                    <div class="col-4">SCHEMA FEES</div>
                    <div class="col-1"></div>
                    <div class="col-2">
                      {{ dailyRow.TotalSchemaFees }}
                    </div>
                    <div class="col-1"></div>
                    <div
                      v-if="dailyRow.TotalPaymentShareInCents < 0"
                      class="col-2"
                    ></div>
                    <div class="col-2">
                      {{ dailyRow.TotalSchemaFees }}
                    </div>
                  </div>
                  <div v-if="dailyRow.TotalMarkupFees < 0" class="row">
                    <div class="col-4">MARKUP FEES</div>
                    <div class="col-1"></div>
                    <div class="col-2">
                      {{ dailyRow.TotalMarkupFees }}
                    </div>
                    <div class="col-1"></div>
                    <div
                      v-if="dailyRow.TotalPaymentShareInCents < 0"
                      class="col-2"
                    ></div>
                    <div class="col-2">
                      {{ dailyRow.TotalMarkupFees }}
                    </div>
                  </div>
                  <div v-if="dailyRow.TotalInterchangeFees < 0" class="row">
                    <div class="col-4">INTERCHANGE FEES</div>
                    <div class="col-1"></div>
                    <div class="col-2">
                      {{ dailyRow.TotalInterchangeFees }}
                    </div>
                    <div class="col-1"></div>
                    <div
                      v-if="dailyRow.TotalPaymentShareInCents < 0"
                      class="col-2"
                    ></div>
                    <div class="col-2">
                      {{ dailyRow.TotalInterchangeFees }}
                    </div>
                  </div>
                  <div v-if="dailyRow.TotalAdyenPPCInCents < 0" class="row">
                    <div class="col-4">ADYEN PPC</div>
                    <div class="col-1">{{ dailyRow.TotalAdyenPPCCount }}</div>
                    <div class="col-2">
                      {{ dailyRow.TotalAdyenPPCInCents / 100 }}
                    </div>
                    <div class="col-1"></div>
                    <div
                      v-if="dailyRow.TotalAdyenPPCInCents < 0"
                      class="col-2"
                    ></div>
                    <div class="col-2">
                      {{ dailyRow.TotalAdyenPPCInCents / 100 }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">TOTAL</div>
                    <div class="col-1">{{ dailyRow.TotalCount }}</div>
                    <div class="col-2">
                      {{ dailyRow.TotalAmountInCents / 100 }}
                      {{ report.Currency }}
                    </div>
                    <div class="col-1"></div>
                    <div
                      v-if="dailyRow.TotalPaymentShareInCents < 0"
                      class="col-2"
                    >
                      {{ dailyRow.TotalPaymentShareInCents / 100 }}
                      {{ report.Currency }}
                    </div>
                    <div class="col-2">
                      {{ dailyRow.TotalPaymentInCents / 100 }}
                      {{ report.Currency }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="
            reportData && reportData.SubscriptionPlansReportView.TotalCount > 0
          "
          class="panel panel-default col-12"
        >
          <div class="panel-body">
            <div class="row">
              <div class="col-4 font-weight-bold">Subscriptions</div>
              <div class="col-1 font-weight-bold">Count</div>
              <div class="col-2 font-weight-bold">Amount</div>
              <div class="col-1 font-weight-bold">%</div>
              <div class="col-2 font-weight-bold">PPC</div>
              <div class="col-2 font-weight-bold">Payment</div>
            </div>
            <div
              v-for="report in reportData.SubscriptionPlansReportView
                .SubscriptionPlanReportViews"
              :key="report.Id"
            >
              <div v-if="report.TotalCount > 0" class="row">
                <div class="col-4">{{ report.SubscriptionPlanName }}</div>
                <div class="col-1">{{ report.TotalCount }}</div>
                <div class="col-2">
                  {{ report.TotalAmountInCents / 100 }}
                </div>
                <div class="col-1">
                  {{ getOwnerShareBySubscription(report, false) }}
                </div>
                <div class="col-2">
                  <span v-if="report.TotalPaymentShareInCents < 0">
                    {{ report.TotalPaymentShareInCents / 100 }}
                  </span>
                </div>
                <div class="col-2">
                  {{ report.TotalPaymentInCents / 100 }}
                </div>
              </div>
              <div v-if="report.TotalRefundCount > 0" class="row">
                <div class="col-4">
                  {{ report.SubscriptionPlanName }} REFUND
                </div>
                <div class="col-1">{{ report.TotalRefundCount }}</div>
                <div class="col-2">
                  {{ report.TotalRefundAmountInCents / 100 }}
                </div>
                <div class="col-1">
                  {{ getOwnerShareBySubscription(report, true) }}
                </div>
                <div
                  v-if="report.TotalPaymentShareInCents < 0"
                  class="col-2"
                ></div>
                <div class="col-2">
                  {{ report.TotalRefundInCents / 100 }}
                </div>
              </div>
            </div>
            <div
              v-if="reportData.SubscriptionPlansReportView.TotalSchemaFees < 0"
              class="row"
            >
              <div class="col-4">SCHEMA FEES</div>
              <div class="col-1"></div>
              <div class="col-2">
                {{ reportData.SubscriptionPlansReportView.TotalSchemaFees }}
              </div>
              <div class="col-1"></div>
              <div
                v-if="
                  reportData.SubscriptionPlansReportView
                    .TotalPaymentShareInCents < 0
                "
                class="col-2"
              ></div>
              <div class="col-2">
                {{ reportData.SubscriptionPlansReportView.TotalSchemaFees }}
              </div>
            </div>
            <div
              v-if="reportData.SubscriptionPlansReportView.TotalMarkupFees < 0"
              class="row"
            >
              <div class="col-4">MARKUP FEES</div>
              <div class="col-1"></div>
              <div class="col-2">
                {{ reportData.SubscriptionPlansReportView.TotalMarkupFees }}
              </div>
              <div class="col-1"></div>
              <div
                v-if="
                  reportData.SubscriptionPlansReportView
                    .TotalPaymentShareInCents < 0
                "
                class="col-2"
              ></div>
              <div class="col-2">
                {{ reportData.SubscriptionPlansReportView.TotalMarkupFees }}
              </div>
            </div>
            <div
              v-if="
                reportData.SubscriptionPlansReportView.TotalInterchangeFees < 0
              "
              class="row"
            >
              <div class="col-4">INTERCHANGE FEES</div>
              <div class="col-1"></div>
              <div class="col-2">
                {{
                  reportData.SubscriptionPlansReportView.TotalInterchangeFees
                }}
              </div>
              <div class="col-1"></div>
              <div
                v-if="
                  reportData.SubscriptionPlansReportView
                    .TotalPaymentShareInCents < 0
                "
                class="col-2"
              ></div>
              <div class="col-2">
                {{
                  reportData.SubscriptionPlansReportView.TotalInterchangeFees
                }}
              </div>
            </div>
            <div class="row">
              <div class="col-4">TOTAL</div>
              <div class="col-1">
                {{ reportData.SubscriptionPlansReportView.TotalCount }}
              </div>
              <div class="col-2">
                {{
                  reportData.SubscriptionPlansReportView.TotalAmountInCents /
                    100
                }}
                {{ reportData.SubscriptionPlansReportView.Currency }}
              </div>
              <div class="col-1"></div>
              <div
                v-if="
                  reportData.SubscriptionPlansReportView
                    .TotalPaymentShareInCents < 0
                "
                class="col-2"
              >
                {{
                  reportData.SubscriptionPlansReportView
                    .TotalPaymentShareInCents / 100
                }}
                {{ reportData.SubscriptionPlansReportView.Currency }}
              </div>
              <div class="col-2">
                {{
                  reportData.SubscriptionPlansReportView.TotalPaymentInCents /
                    100
                }}
                {{ reportData.SubscriptionPlansReportView.Currency }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-card-text>
    <v-card-text v-else>
      <v-toolbar class="elevation-0">
        <v-spacer></v-spacer>
        <v-progress-circular
          indeterminate
          color="secondary"
        ></v-progress-circular>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'
import axios from 'axios'

// const gradients = [
//   ['#222'],
//   ['#42b3f4'],
//   ['red', 'orange', 'yellow'],
//   ['purple', 'violet'],
//   ['#00c6ff', '#F0F', '#FF0'],
//   ['#f72047', '#ffd200', '#1feaea']
// ]
export default {
  name: 'PayoutReport',
  mixins: [formatDate],
  data() {
    return {
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      validFromPicker: false,
      validToPicker: false,
      selectedValidFrom: '',
      selectedValidTo: '',
      selectedRegion: '',
      selectedType: '',
      selectedReportZone: '',
      selectedOperator: '',
      selectedPlace: '',
      selectedGroupByValue: 'PLACE',
      reportData: null,
      selectedReportRow: {},
      financeData: null,
      localLoading: true
    }
  },
  computed: {
    ...mapGetters('app', ['loading', 'error']),
    ...mapGetters('authentication', ['user', 'isGlobalAdmin']),
    ...mapGetters('reports', ['reportTypes', 'operators']),
    ...mapGetters('users', [
      'userRegions',
      'userZones',
      'userPlaces',
      'sortedUserPlaces'
    ]),
    selectedReportType: {
      get() {
        return this.$store.state.reports.selectedReportType
      },
      set(val) {
        this.$store.commit('reports/setSelectedReportType', val)
      }
    }
  },
  watch: {
    operators() {
      if (this.operators.length) {
        this.localLoading = false
      }
    }
  },
  async created() {
    await this.getReportTypes()
    if (this.user.region && this.user.region !== '') {
      // Set selectedRegion based on user region if exists
      this.selectedRegion = this.user.region
    } else {
      this.getUserRegions().then(async () => {
        // Set region to EST for global admin, else select first from userRegions Array
        if (this.isGlobalAdmin) {
          this.selectedRegion = 'EST'
        } else {
          const firstRegion = this.userRegions[0]
          this.selectedRegion = firstRegion
        }
        await this.getUserZones({
          region: this.selectedRegion,
          type: this.selectedType
        })
        await this.getOperators({
          region: this.selectedRegion,
          type: this.selectedType
        })
        if (this.userZones.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          this.selectedReportZone = this.userZones[0]
        }
        if (this.operators.length === 1) {
          // eslint-disable-next-line prefer-destructuring
          this.selectedOperator = this.operators[0]
        }
      })
    }

    // Set selectedType based on user place_types if exists
    if (this.user.place_types && this.user.place_types.length) {
      const firstPlaceType = this.user.place_types[0]
      this.selectedType = firstPlaceType
    }

    // Set selectedValidFrom to current month first day
    const currentDate = new Date()
    this.selectedValidFrom = this.formatDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    )
    // Set selectedValidTo to current day
    this.selectedValidTo = this.formatDate(new Date())

    await this.getUserPlaces({ region: this.selectedRegion })
    if (this.userPlaces && this.userPlaces.length) {
      // eslint-disable-next-line prefer-destructuring
      this.selectedPlace = this.sortedUserPlaces[0]
    }
  },
  methods: {
    ...mapActions('reports', [
      'getReportTypes',
      'getOperators',
      'getPayoutXLSX',
      'getFinanceXLSX'
    ]),
    ...mapActions('users', ['getUserRegions', 'getUserZones', 'getUserPlaces']),
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    },
    // Returns array of numbers, eg. with input(1,12) [1,2,3,.....,12]
    range(from, to) {
      const list = []
      for (let i = from; i <= to; i += 1) {
        list.push(i)
      }
      return list
    },
    async generatePayoutReport() {
      if (this.selectedReportType.Code === 'PAYOUT') {
        this.$store
          .dispatch('reports/getReportRows', {
            from: `${this.selectedValidFrom} 00:00:00`,
            to: `${this.selectedValidTo} 23:59:59`,
            region: this.selectedRegion,
            type: this.selectedType,
            reportType: this.selectedReportType.Code,
            groupBy: this.selectedGroupByValue,
            placeId: this.selectedPlace.Id,
            zone: this.selectedReportZone
          })
          .then(response => {
            this.reportData = response
            this.financeData = null
          })
      } else if (this.selectedReportType.Code === 'FINANCE') {
        await this.getFinanceXLSX({
          from: `${this.selectedValidFrom} 00:00:00`,
          to: `${this.selectedValidTo} 23:59:59`,
          region: this.selectedRegion,
          type: this.selectedType !== 'ALL TYPES' ? this.selectedType : '',
          reportType: this.selectedReportType,
          accept: 'json',
          responseType: 'json'
        }).then(response => {
          this.financeData = response.data
          this.reportData = null
        })
      } else {
        const lastDayOfSelectedMonth = this.daysInMonth(
          this.selectedMonth,
          this.selectedYear
        )
        this.$store
          .dispatch('reports/getReportRows', {
            from: `${this.selectedYear}-${this.selectedMonth}-01 00:00:00`,
            to: `${this.selectedYear}-${this.selectedMonth}-${lastDayOfSelectedMonth} 23:59:59`,
            region: this.selectedRegion,
            type: this.selectedType,
            reportType: this.selectedReportType.Code,
            groupBy: this.selectedGroupByValue,
            placeId: this.selectedPlace.Id,
            zone: this.selectedReportZone
          })
          .then(response => {
            this.reportData = response
            this.financeData = null
          })
      }
    },
    async sendPayoutReportToEmail() {
      if (this.selectedReportType.Code === 'PAYOUT') {
        this.$store
          .dispatch('reports/getReportRows', {
            from: `${this.selectedValidFrom} 00:00:00`,
            to: `${this.selectedValidTo} 23:59:59`,
            region: this.selectedRegion,
            type: this.selectedType,
            reportType: this.selectedReportType.Code,
            groupBy: this.selectedGroupByValue,
            placeId: this.selectedPlace.Id,
            zone: this.selectedReportZone,
            sendToEmail: true
          })
          .then(response => {
            this.reportData = response
            this.financeData = null
            
            this.$store.commit(
              'app/setSnackbar',
              {
                show: true,
                type: 'success',
                message: response.Message
              },
              { root: true }
            )

          })
      } else if (this.selectedReportType.Code === 'FINANCE') {
        await this.getFinanceXLSX({
          from: `${this.selectedValidFrom} 00:00:00`,
          to: `${this.selectedValidTo} 23:59:59`,
          region: this.selectedRegion,
          type: this.selectedType !== 'ALL TYPES' ? this.selectedType : '',
          reportType: this.selectedReportType,
          accept: 'json',
          responseType: 'json',
          sendToEmail: true
        }).then(response => {
          this.financeData = response.data
          this.reportData = null
        })
      } else {
        const lastDayOfSelectedMonth = this.daysInMonth(
          this.selectedMonth,
          this.selectedYear
        )
        this.$store
          .dispatch('reports/getReportRows', {
            from: `${this.selectedYear}-${this.selectedMonth}-01 00:00:00`,
            to: `${this.selectedYear}-${this.selectedMonth}-${lastDayOfSelectedMonth} 23:59:59`,
            region: this.selectedRegion,
            type: this.selectedType,
            reportType: this.selectedReportType.Code,
            groupBy: this.selectedGroupByValue,
            placeId: this.selectedPlace.Id,
            zone: this.selectedReportZone,
            sendToEmail: true
          })
          .then(response => {
            this.reportData = response
            this.financeData = null
          })
      }
    },
    getPayoutReport() {
      if (this.selectedReportType.Code === 'PAYOUT') {
        this.getPayoutXLSX({
          from: `${this.selectedValidFrom} 00:00:00`,
          to: `${this.selectedValidTo} 23:59:59`,
          region: this.selectedRegion,
          type: this.selectedType,
          reportType: this.selectedReportType.Code,
          groupBy: this.selectedGroupByValue,
          placeId: this.selectedPlace.Id
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `${this.$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REPORT')}-${
              this.selectedMonth
            }-${this.selectedYear}.xlsx`
          )
          document.body.appendChild(link)
          link.click()
        })
      } else if (this.selectedReportType.Code === 'FINANCE') {
        this.getFinanceXLSXReport()
      } else {
        const lastDayOfSelectedMonth = this.daysInMonth(
          this.selectedMonth,
          this.selectedYear
        )
        this.getPayoutXLSX({
          from: `${this.selectedYear}-${this.selectedMonth}-01 00:00:00`,
          to: `${this.selectedYear}-${this.selectedMonth}-${lastDayOfSelectedMonth} 23:59:59`,
          region: this.selectedRegion,
          type: this.selectedType,
          reportType: this.selectedReportType.Code,
          groupBy: this.selectedGroupByValue,
          placeId: this.selectedPlace.Id
        }).then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            `${this.$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REPORT')}-${
              this.selectedMonth
            }-${this.selectedYear}.xlsx`
          )
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    async getFinanceXLSXReport() {
      this.getFinanceXLSX({
        from: `${this.selectedValidFrom} 00:00:00`,
        to: `${this.selectedValidTo} 23:59:59`,
        region: this.selectedRegion,
        type: this.selectedType !== 'ALL TYPES' ? this.selectedType : '',
        reportType: this.selectedReportType.Code,
        groupBy: this.selectedGroupByValue,
        placeId: this.selectedPlace.Id
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `${this.$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.REPORT')}-${
            this.selectedMonth
          }-${this.selectedYear}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
      })
    },
    getOwnerShareByPaymentMethod(row) {
      if (row.PaymentMethod.indexOf('CREDITCARD') !== -1) {
        return row.PaymentProfile.CreditSharePercent
      }
      if (row.PaymentMethod.indexOf('MOBILE') !== -1) {
        return row.PaymentProfile.MobileSharePercent
      }
      if (row.PaymentMethod.indexOf('PREPAID_CREDIT') !== -1) {
        return row.PaymentProfile.PrepaidSharePercent
      }
      if (row.PaymentMethod.indexOf('SUBSCRIPTION') !== -1) {
        return row.PaymentProfile.SubscriptionSharePercent
      }
      return ''
    },
    async showReportDetails(report) {
      const reportInAction = this.reportData.GroupViews.find(rep => {
        return rep.Id === report.Id
      })
      if (reportInAction.showingDetails) {
        reportInAction.showingDetails = false
        this.selectedReportRow = false
        return
      }
      reportInAction.showingDetails = !reportInAction.showingDetails

      // this.selectedReportRow = reportInAction

      let id = report.Id
      if (this.selectedGroupByValue === 'ZONE') {
        id = report.Name
      }
      const config = {
        params: {
          from: `${this.selectedValidFrom} 00:00:00`,
          to: `${this.selectedValidTo} 23:59:59`,
          region: this.selectedRegion,
          type: this.selectedType,
          reportType: this.selectedReportType.Code,
          groupBy: this.selectedGroupByValue,
          placeId: this.selectedPlace.Id
        },
        responseType: 'json',
        headers: {
          Authorization: `Bearer ${this.user.token}`
        }
      }

      await axios
        .get(
          `${process.env.VUE_APP_URL}/adminapi/reports/${id}/details`,
          config
        )
        .then(data => {
          reportInAction.details = data.data
          this.selectedReportRow = reportInAction
        })
    },
    getPreviousMonday() {
      const beforeOneWeek = new Date(
        new Date().getTime() - 60 * 60 * 24 * 7 * 1000
      )
      const day = beforeOneWeek.getDay()
      const diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1)
      const lastMonday = new Date(beforeOneWeek.setDate(diffToMonday))

      return this.formatDate(lastMonday)
    },
    setSelectedDateRange(option) {
      const date = new Date()
      const currentYear = new Date().getFullYear()
      const currentMonth = new Date().getMonth()
      const lastMonth = date.getMonth() - 1
      const weekstart = date.getDate() - date.getDay() + 1
      const weekend = weekstart + 4
      const monday = new Date(date.setDate(weekstart))
      const sunday = new Date(date.setDate(weekend))

      switch (option) {
        case 0: // Eelmise kuu algusest
          this.selectedValidFrom = this.formatDate(
            new Date(currentYear, lastMonth, 1)
          )
          this.selectedValidTo = this.formatDate(new Date())
          break
        case 1: // Eelmine kuu
          this.selectedValidFrom = this.formatDate(
            new Date(currentYear, lastMonth, 1)
          )
          this.selectedValidTo = this.formatDate(
            new Date(currentYear, currentMonth, 0)
          )
          break
        case 2: // Jooksev kuu
          this.selectedValidFrom = this.formatDate(
            new Date(new Date().getFullYear(), new Date().getMonth(), 1)
          )
          this.selectedValidTo = this.formatDate(new Date())
          break
        case 3: // Eelmine nädal
          this.selectedValidFrom = this.getPreviousMonday()
          this.selectedValidTo = this.formatDate(
            new Date(
              date.setTime(
                date.getTime() -
                  (date.getDay() ? date.getDay() : 7) * 24 * 60 * 60 * 1000
              )
            )
          )
          break
        case 4: // Jooksev nädal
          this.selectedValidFrom = this.formatDate(monday)
          this.selectedValidTo = this.formatDate(sunday)
          break
        case 5: // Eile
          this.selectedValidFrom = this.formatDate(new Date(Date.now() - 864e5)) // 864e5 == 86400000 == 24*60*60*1000
          this.selectedValidTo = this.formatDate(new Date(Date.now() - 864e5)) // 864e5 == 86400000 == 24*60*60*1000
          break
        case 6: // Täna
          this.selectedValidFrom = this.formatDate(new Date())
          this.selectedValidTo = this.formatDate(new Date())
          break
        case 7: // Viimased 7 päeva
          this.selectedValidFrom = this.formatDate(
            new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
          )
          this.selectedValidTo = this.formatDate(new Date())
          break

        default:
          break
      }
    },
    daysInMonth(month, year) {
      return new Date(year, month, 0).getDate()
    }
  }
}
</script>
